import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { IlamyCalendar } from '@ilamy/calendar'
import dayjs from 'dayjs'
import { toggleModal } from '../../store/board.actions'

export function BoardCalendar({ board }) {
    const isOpen = useSelector(storeState => storeState.boardModule.isBoardModalOpen)
    const navigate = useNavigate()

    const events = []
    board.groups.forEach(group => {
        group.tasks.forEach(task => {
            if (task.dueDate) {
                const start = dayjs(task.dueDate)
                events.push({
                    id: task.id,
                    title: task.title,
                    start,
                    end: start.add(1, 'hour'),
                    color: group.color,
                    data: { group, task },
                })
            }
        })
    })

    function onEventClick(event) {
        const { group, task } = event.data
        toggleModal(isOpen)
        navigate(`/board/${board._id}/${group.id}/${task.id}`)
    }

    return (
        <section className="board-calendar">
            <IlamyCalendar
                events={events}
                initialView="week"
                firstDayOfWeek="sunday"
                onEventClick={onEventClick}
                eventHeight={28}
                dayMaxEvents={4}
                hideExportButton
                disableDragAndDrop
            />
        </section>
    )
}
